// extracted by mini-css-extract-plugin
module.exports = {"Loader":"SpinnerDark_Loader__3BxkG","load6":"SpinnerDark_load6__JXXks","round":"SpinnerDark_round__3HeSK"};